/**
 * f11.6: one line's warnings, as the grid tooltip and the review screen (f12.1)
 * both show them -- a "Check input" group (validation) above a "Calculation"
 * group (the engine's stored `result.warnings`). Amber, never the danger style.
 */

import type { EngineWarning, ValidationWarning } from '@/api/client';

import {
  CALCULATION_GROUP,
  CHECK_INPUT_GROUP,
  VALIDATION_WARNING_CATALOG,
  orderedWarnings,
  visibleEngineWarnings,
} from './validationWarningCatalog';

interface ValidationWarningListProps {
  warnings: readonly ValidationWarning[];
  engineWarnings?: readonly EngineWarning[];
}

export function ValidationWarningList({ warnings, engineWarnings = [] }: ValidationWarningListProps) {
  const checks = orderedWarnings(warnings);
  const engine = visibleEngineWarnings(engineWarnings, warnings);
  if (!checks.length && !engine.length) return null;
  return (
    <div className="vw-list">
      {checks.length > 0 && (
        <section aria-label={CHECK_INPUT_GROUP}>
          <h4 className="vw-group">{CHECK_INPUT_GROUP}</h4>
          <ul>
            {checks.map((w) => (
              <li key={w.code} data-code={w.code}>
                <span className="vw-label">{VALIDATION_WARNING_CATALOG[w.code].label}</span>
                <span className="vw-message">{w.message}</span>
              </li>
            ))}
          </ul>
        </section>
      )}
      {engine.length > 0 && (
        <section aria-label={CALCULATION_GROUP}>
          <h4 className="vw-group">{CALCULATION_GROUP}</h4>
          <ul>
            {engine.map((w, index) => (
              <li key={`${w.code}-${w.period_month ?? index}`} data-code={w.code}>
                <span className="vw-message">{w.message}</span>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
}
